import { IsUpgradeSiteMicroserviceEnabled } from "../envVariables";
import { AuthorizedApiBase } from "./authorized-api-base";
import {
  ApiException,
  ChangesDetail,
  FileResponse,
  HQSiteChangesDTO,
  HQSiteDetailsDTO,
  ProblemDetails,
} from "./taxportal-client";

export interface SitetemplateDTO {
  id?: number;
  sitename?: string | undefined;
}

export interface ComparisonResultDTO {
  created?: string;
  createdBy?: string;
  lastModified?: string;
  lastModifiedBy?: string;
  id?: number;
  originTemplateId?: number;
  originTemplateName?: string;
  targetTemplateId?: number;
  targetTemplateName?: string;
  comparisonTagName?: string;
  appName?: string;
}

export interface ComparisonResultDetailDTO {
  created?: string;
  createdBy?: string;
  lastModified?: string;
  lastModifiedBy?: string;
  id?: number;
  hqUpgradeSiteCompareId?: number;
  comparisonId?: string;
  module?: string;
  change?: string;
  object?: string;
  changeDetails?: ChangesDetail[];
  selected?: boolean;
}

export interface PostBatchUpgradeTemplatesComparisonRequest {
  originTemplateId?: number;
  originTemplateName?: string;
  targetTemplateId?: number;
  targetTemplateName?: string;
  appName?: string;
  userName?: string;
  comparisonTagName?: string;
  siteChanges?: any[];
}

export interface GetSitesDetailsResponse {
  offset: number;
  limit: number;
  totalCount: number;
  sitesUpgradeList: HQSiteDetailsDTO[];
}

export class UpgradeSiteServiceClient extends AuthorizedApiBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  highQ_GetHQSiteTemplate(
    appName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<SitetemplateDTO[]> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? "/api/v1/SiteTemplate/GetSiteTemplates?"
        : "/api/siteTemplate?");
    if (appName !== undefined && appName !== null)
      url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetHQSiteTemplate(_response);
      });
  }

  protected processHighQ_GetHQSiteTemplate(
    response: Response
  ): Promise<SitetemplateDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SitetemplateDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SitetemplateDTO[]>(null as any);
  }

  highQ_GetSitesUpgradeByStatus(
    status: string | null,
    userCountry: string | null,
    offset: number | undefined,
    limit: number | undefined,
    appName: string,
    currentTemplate?: string | null,
    isSiteComment?: boolean | null,
    isCustomPermission?: boolean | null
  ): Promise<GetSitesDetailsResponse> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? "/api/v1/SiteUpgradeStatus/GetSitesUpgradeByStatus?"
        : "/api/GetSitesUpgradeByStatus?");
    if (status === undefined)
      throw new Error("The parameter 'status' must be defined.");
    else if (status !== null)
      url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (userCountry !== undefined && userCountry !== null)
      url_ += "UserCountry=" + encodeURIComponent("" + userCountry) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (appName !== undefined && appName !== null)
      url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (currentTemplate !== undefined && currentTemplate !== null)
      url_ += "currentTemplate=" + encodeURIComponent("" + currentTemplate) + "&";
    if (isSiteComment !== undefined && isSiteComment !== null)
      url_ += "isSiteComment=" + encodeURIComponent("" + isSiteComment) + "&";
    if (isCustomPermission !== undefined && isCustomPermission !== null)
      url_ += "isCustomPermission=" + encodeURIComponent("" + isCustomPermission) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processhighQ_GetSitesUpgradeByStatus(_response);
      });
  }
  protected processhighQ_GetSitesUpgradeByStatus(
    response: Response
  ): Promise<GetSitesDetailsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as GetSitesDetailsResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetSitesDetailsResponse>(null as any);
  }

  highQ_GetSitesUpgradeBySearch(
    status: string | null,
    userCountry: string | null,
    searchTerm: string | null,
    appName: string | null,
    offset: number | undefined,
    limit: number | undefined,
    isSiteComment?: boolean | null,
    isCustomPermission?: boolean | null,
    currentTemplate?: string | null
  ): Promise<GetSitesDetailsResponse> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? "/api/v1/SiteUpgradeStatus/GetSitesUpgradeByStatus?"
        : "/api/GetSitesUpgradeBySearch?");
    if (searchTerm === undefined)
      throw new Error("The parameter 'searchTerm' must be defined.");
    if (status !== null)
      url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (userCountry !== null)
      url_ += "UserCountry=" + encodeURIComponent("" + userCountry) + "&";
    if (searchTerm !== null)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (appName !== undefined && appName !== null)
      url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (isSiteComment !== undefined && isSiteComment !== null)
      url_ += "isSiteComment=" + encodeURIComponent("" + isSiteComment) + "&";
    if (isCustomPermission !== undefined && isCustomPermission !== null)
      url_ += "isCustomPermission=" + encodeURIComponent("" + isCustomPermission) + "&";
    if (currentTemplate !== undefined && currentTemplate !== null)
      url_ += "currentTemplate=" + encodeURIComponent("" + currentTemplate) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processhighQ_GetSitesUpgradeBySearch(_response);
      });
  }
  protected processhighQ_GetSitesUpgradeBySearch(
    response: Response
  ): Promise<GetSitesDetailsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as GetSitesDetailsResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetSitesDetailsResponse>(null as any);
  }

  highQ_GetSitesUpgradeDetailStatus(
    idUpgradeSiteTracks: string | null
  ): Promise<HQSiteChangesDTO> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/SiteUpgradeStatus/GetSitesUpgradeDetailStatus?siteUpgradeId=`
        : `/api/GetSitesUpgradeDetailStatus?siteUpgradeId=`);
    if (idUpgradeSiteTracks === undefined)
      throw new Error("The parameter 'idUpgradeSiteTracks' must be defined.");
    if (idUpgradeSiteTracks !== null)
      url_ += encodeURIComponent("" + idUpgradeSiteTracks) + "?";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processhighQ_GetSitesUpgradeDetailStatus(_response);
      });
  }
  protected processhighQ_GetSitesUpgradeDetailStatus(
    response: Response
  ): Promise<HQSiteChangesDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as HQSiteChangesDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<HQSiteChangesDTO>(null as any);
  }

  highQ_ExportToExcelForUpgradeSites(
    appName: string | undefined,
    status: string | null | undefined,
    signal?: AbortSignal
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/SiteUpgradeExport/ExportToExcelForUpgradeSites?`
        : `/api/SiteUpgradeExport/ExportToExcelForUpgradeSites?`);

    if (appName === null)
      throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined)
      url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (status !== undefined && status !== null)
      url_ += "status=" + encodeURIComponent("" + status) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/octet-stream",
      },
    };

     return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processhighQ_ExportToExcelForUpgradeSites(_response);
      });
  }
  protected processhighQ_ExportToExcelForUpgradeSites(
    response: Response
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  taxPortal_UpgradeWithoutCompare(
    templateId: string,
    siteId: number,
    userName: string
  ): Promise<any[]> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/OrchestrationApply/CompareAndApplySiteUpgradeComparison/`
        : `/api/CompareTemplateSitesAndApplyChanges`);
    if (IsUpgradeSiteMicroserviceEnabled === "true") {
      url_ +=
        encodeURIComponent("" + templateId) +
        "?siteId=" +
        encodeURIComponent("" + siteId);
    } else {
      url_ +=
        "?templateId=" +
        encodeURIComponent("" + templateId) +
        "&siteId=" +
        encodeURIComponent("" + siteId);
    }
    if (userName === undefined || userName === null)
      throw new Error(
        "The parameter 'userName' must be defined and cannot be null."
      );
    url_ = url_.replace(/[?&]$/, "");
    let options_: RequestInit = {
      method: "PUT",
      headers: {
        userName:
          userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_BatchUpgradeUpgradeSites(_response);
      });
  }

  protected processTaxPortal_BatchUpgradeUpgradeSites(
    response: Response
  ): Promise<any[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as any[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<any[]>(null as any);
  }

  taxPortal_ProceedToUpgradeSites(
    templateId: string,
    siteChanges: HQSiteChangesDTO[],
    userName: string,
    isBatchUpgrade: boolean
  ): Promise<HQSiteChangesDTO[]> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/OrchestrationApply/ApplySiteUpgradeComparison/${templateId}`
        : `/api/HQTemplateSiteComparison/${templateId}`);
    if (isBatchUpgrade)
      url_ += "?isBatchUpgrade=" + encodeURIComponent("" + isBatchUpgrade);
    if (userName === undefined || userName === null)
      throw new Error(
        "The parameter 'userName' must be defined and cannot be null."
      );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteChanges);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        userName:
          userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ProceedToUpgradeSites(_response);
      });
  }
  protected processTaxPortal_ProceedToUpgradeSites(
    response: Response
  ): Promise<HQSiteChangesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as HQSiteChangesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<HQSiteChangesDTO[]>(null as any);
  }

  taxPortal_ScheduleUpgradeSites(
    siteIds: number[],
    comparisionTagName: string,    
    userName: string,
  ): Promise<boolean> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/SiteUpgradeComparisonResults/ScheduleSiteUpgrade?`
        : `/api/SiteUpgradeComparisonResults/ScheduleSiteUpgrade?`);
    if (comparisionTagName === undefined || comparisionTagName === null)
      throw new Error(
        "The parameter 'comparisionTagName' must be defined and cannot be null."
      );
    if (userName === undefined || userName === null)
      throw new Error(
        "The parameter 'userName' must be defined and cannot be null."
      );
    url_ +=
      "comparisionTagName=" + encodeURIComponent("" + comparisionTagName) + "&";
  
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteIds);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        userName:
        userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ScheduleUpgradeSites(_response);
      });
  } 
  protected processTaxPortal_ScheduleUpgradeSites(
    response: Response
  ): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  highQ_TemplateSiteComparison(
    targetTemplateId: string | null,
    siteId: string | null,
    isBatchUpgrade: boolean
  ): Promise<HQSiteChangesDTO[]> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/OrchestrationComparison/GetTemplateSiteComparison/`
        : `/api/HQTemplateSiteComparison/`);
    if (targetTemplateId === undefined)
      throw new Error("The parameter 'targetTemplateId' must be defined.");
    if (siteId === undefined)
      throw new Error("The parameter 'siteId' must be defined.");
    if (targetTemplateId !== null) url_ += encodeURIComponent("" + targetTemplateId) + "?";
    if (siteId !== null)
      url_ += "siteIds=" + encodeURIComponent("" + siteId) + "&";
    url_ += "isBatchUpgrade=" + encodeURIComponent("" + isBatchUpgrade);

    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processhighQ_TemplateSiteComparison(_response);
      });
  }
  protected processhighQ_TemplateSiteComparison(
    response: Response
  ): Promise<HQSiteChangesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as HQSiteChangesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<HQSiteChangesDTO[]>(null as any);
  }

  HQTemplateSiteExcelExport(
    messages?: HQSiteChangesDTO,
    isUpgradeResult = true
  ): Promise<string> {
    let endpoint;
    if (IsUpgradeSiteMicroserviceEnabled === "true") {
      endpoint = isUpgradeResult
        ? "ExportSiteUpgradeResults?isComparisonDetailsExport=false"
        : "ExportSiteUpgradeResults?isComparisonDetailsExport=true";
    } else {
      endpoint = isUpgradeResult
        ? "HQTemplateSiteUpgradeResultExcelExport"
        : "HQTemplateSiteComparisonExcelExport";
    }
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/SiteUpgradeExport/${endpoint}`
        : `/api/${endpoint}`);
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQTemplateSiteExcelExport(_response);
      });
  }
  protected processHQTemplateSiteExcelExport(
    response: Response
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.arrayBuffer().then((arrayBuffer) => {
        const base64String = this.arrayBufferToBase64(arrayBuffer);
        let result200: any = null;
        result200 = base64String === "" ? null : base64String;
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  protected arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  HQTemplateSiteUpgradeResultExcelExport(
    sites: number[]
  ): Promise<ArrayBuffer> {
    if (sites === undefined)
      throw new Error("The parameter 'siteId' must be defined.");
    const sitesUrl = sites.join("&siteUpgradeIds=");
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/SiteUpgradeExport/ExportMultipleSiteUpgradeResults?siteUpgradeIds=${sitesUrl}`
        : `/api/HQTemplateSiteUpgradeResultExcelExport?siteUpgradeIds=${sitesUrl}`);
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQTemplateSiteUpgradeResultExcelExport(_response);
      });
  }
  protected processHQTemplateSiteUpgradeResultExcelExport(
    response: Response
  ): Promise<ArrayBuffer> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.arrayBuffer().then((arrayBuffer) => {
        return arrayBuffer;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ArrayBuffer>(null as any);
  }

  taxPortal_RetryBatchUpgradeUpgradeSites(
    templateId: string,
    siteId: number,
    userName: string
  ): Promise<any[]> {
    let url_ =
      this.baseUrl +
      (IsUpgradeSiteMicroserviceEnabled === "true"
        ? `/api/v1/OrchestrationApply/RetryApplySiteUpgradeComparison/`
        : `/api/RetryApplyHQTemplateSitesComparisonChanges`);
    if (IsUpgradeSiteMicroserviceEnabled === "true") {
      url_ +=
        encodeURIComponent("" + templateId) +
        "?siteId=" +
        encodeURIComponent("" + siteId);
    } else {
      url_ +=
        "?templateId=" +
        encodeURIComponent("" + templateId) +
        "&siteId=" +
        encodeURIComponent("" + siteId);
    }
    if (userName === undefined || userName === null)
      throw new Error(
        "The parameter 'userName' must be defined and cannot be null."
      );
    url_ = url_.replace(/[?&]$/, "");
    let options_: RequestInit = {
      method: "PUT",
      headers: {
        userName:
          userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_BatchUpgradeUpgradeSites(_response);
      });
  }

  getAll_HighQTemplates(
    appName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<SitetemplateDTO[]> {
    if (IsUpgradeSiteMicroserviceEnabled !== "true") {
      return Promise.reject(
        new Error("GetAllHighQTemplates API is only available when upgrade site microservice is enabled")
      );
    }

    let url_ = this.baseUrl + "/api/v1/SiteUpgradeComparisonResults/GetAllHighQTemplates?";
    if (appName !== undefined && appName !== null)
      url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAll_HighQTemplates(_response);
      });
  }

  protected processGetAll_HighQTemplates(
    response: Response
  ): Promise<SitetemplateDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SitetemplateDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SitetemplateDTO[]>(null as any);
  }

  getComparison_Results(
    appName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<ComparisonResultDTO[]> {
    if (IsUpgradeSiteMicroserviceEnabled !== "true") {
      return Promise.reject(
        new Error("GetComparisonResults API is only available when upgrade site microservice is enabled")
      );
    }

    let url_ = this.baseUrl + "/api/v1/SiteUpgradeComparisonResults/GetComparisonResults?";
    if (appName !== undefined && appName !== null)
      url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetComparison_Results(_response);
      });
  }

  protected processGetComparison_Results(
    response: Response
  ): Promise<ComparisonResultDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ComparisonResultDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ComparisonResultDTO[]>(null as any);
  }

  getComparison_ResultDetails(
    hqUpgradeSiteCompareId: number,
    signal?: AbortSignal
  ): Promise<ComparisonResultDetailDTO[]> {
    if (IsUpgradeSiteMicroserviceEnabled !== "true") {
      return Promise.reject(
        new Error("GetComparisonResultDetails API is only available when upgrade site microservice is enabled")
      );
    }

    let url_ = this.baseUrl + "/api/v1/SiteUpgradeComparisonResults/GetComparisonResultDetails?";
    if (hqUpgradeSiteCompareId !== undefined && hqUpgradeSiteCompareId !== null)
      url_ += "hqUpgradeSiteCompareId=" + encodeURIComponent("" + hqUpgradeSiteCompareId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetComparison_ResultDetails(_response);
      });
  }

  protected processGetComparison_ResultDetails(
    response: Response
  ): Promise<ComparisonResultDetailDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ComparisonResultDetailDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ComparisonResultDetailDTO[]>(null as any);
  }

  postBatchUpgradeTemplatesComparison(
    request: PostBatchUpgradeTemplatesComparisonRequest,
    signal?: AbortSignal
  ): Promise<any> {
    if (IsUpgradeSiteMicroserviceEnabled !== "true") {
      return Promise.reject(
        new Error("PostBatchUpgradeTemplatesComparison API is only available when upgrade site microservice is enabled")
      );
    }

    let url_ = this.baseUrl + "/api/v1/SiteUpgradeComparisonResults/PostBatchUpgradeTemplatesComparison";

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(request),
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostBatchUpgradeTemplatesComparison(_response);
      });
  }

  protected processPostBatchUpgradeTemplatesComparison(
    response: Response
  ): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<any>(null as any);
  }

  updateComparisonResultDetail(
    id: number,
    selected: boolean,
    userName: string,
    signal?: AbortSignal
  ): Promise<any> {
    if (IsUpgradeSiteMicroserviceEnabled !== "true") {
      return Promise.reject(
        new Error("UpdateComparisonResultDetail API is only available when upgrade site microservice is enabled")
      );
    }

    let url_ = this.baseUrl + `/api/v1/SiteUpgradeComparisonResults/ComparisonResultDetails/${id}?`;
    url_ += `selected=${encodeURIComponent("" + selected)}&`;
    url_ += `userName=${encodeURIComponent("" + userName)}`;

    let options_: RequestInit = {
      method: "PUT",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateComparisonResultDetail(_response);
      });
  }

  protected processUpdateComparisonResultDetail(
    response: Response
  ): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 204) {
      return response.text().then((_responseText) => {
        let result: any = null;
        if (_responseText !== "") {
          result = JSON.parse(_responseText, this.jsonParseReviver);
        }
        return result;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<any>(null as any);
  }

  CancelScheduleUpgrade(email: string, payload: any) {
    
    let url_ = `${this.baseUrl}/api/v1/SiteUpgradeStatus/CancelUpgrade`;
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(payload);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        userName: email,
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxPortal_CancelScheduleUpgrade(_response);
      });
  }
 
  protected processtaxPortal_CancelScheduleUpgrade(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

   RetrySiteUpgradeDetailComparison(    
    siteId: number,
    comparisonId: string,
    userName: string
  ): Promise<any[]> {
    let url_ = `${this.baseUrl}/api/v1/OrchestrationApply/RetrySiteUpgradeDetailComparison/`;
        url_ +=
        encodeURIComponent("" + comparisonId) +
        "?siteId=" +
        encodeURIComponent("" + siteId);
          
    if (userName === undefined || userName === null)
      throw new Error(
        "The parameter 'userName' must be defined and cannot be null."
      );
    url_ = url_.replace(/[?&]$/, "");
    let options_: RequestInit = {
      method: "PUT",
      headers: {
        userName:
          userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.process_RetrySiteUpgradeDetailComparison(_response);
      });
  } 
  protected process_RetrySiteUpgradeDetailComparison(
    response: Response
  ): Promise<any[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as any[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<any[]>(null as any);
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
